(function($) {
  'use strict';

  let $acc_trigger = $(".acc-item--title");
  let $acc_target = $(".acc-item--content");
  let $acc_all_trigger = $(".js-accordion-expand-all");

  function runAcc() {

    if ( $(this).hasClass('open') ) {
      $(this).removeClass('open').attr('aria-expanded', 'false');
      $(this).next('.acc-item--content').slideUp('fast');
    } else {
      $(this).addClass('open').attr('aria-expanded', 'true');
      $(this).next('.acc-item--content').slideDown('fast');
    }
  }

  $acc_trigger.on('click', runAcc);

  function runAccAll(e) {
    e.preventDefault();

    // use 'this' and closest() to make sure only the targeted accordion component opens and closes instead of all
    // accordion components on the page (e.g. Loomis Difference > Technology)
    if ( $(this).hasClass('all-open') ) {
      $(this).closest('.component--accordion').find('.js-accordion-expand-all').removeClass('all-open').text('Expand All');
      $(this).closest('.component--accordion').find('.js-accordion-expand-all').removeClass('open').attr('aria-expanded', 'false');
      $(this).closest('.component--accordion').find('.acc-item--content').slideUp('fast');
      $(this).closest('.component--accordion').find('.acc-item--title').removeClass('open'); // remove active states from any open accordion items
    } else {
      $(this).closest('.component--accordion').find('.js-accordion-expand-all').addClass('all-open').text('Close All');
      $(this).closest('.component--accordion').find('.js-accordion-expand-all').addClass('open').attr('aria-expanded', 'true');
      $(this).closest('.component--accordion').find('.acc-item--content').slideDown('fast');
      $(this).closest('.component--accordion').find('.acc-item--title').addClass('open'); // remove active states from any open accordion items
    }
  }

  $acc_all_trigger.on('click', runAccAll);

})(jQuery);
